<template>
  <b-modal
    :visible="shown"
    size="lg"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @hide="handleClose"
    hide-footer>

    <div slot="modal-title">
      <h4 class="m-0">Select your file type</h4>
      <div class="title-description">
        Tell us how you want to use this file
      </div>
    </div>

    <file-type-map
      v-if="shown"
      :meta="meta"
      :file="file"
      @success="handleClose" />

  </b-modal>
</template>

<script>
  import FileTypeMap from './FileTypeMap';

  export default {
    name: 'FileTypeMapModal',
    components: {FileTypeMap},
    props: {
      shown: Boolean,
      meta: Object,
      file: String
    },
    methods: {
      handleClose() {
        this.$emit('close');
      }
    }
  };
</script>

<style scoped>
  .title-description {
    font-weight: normal;
    font-size: .8em;
  }
</style>
